<template>
    <form ref="contactForm" class="flex flex-col gap-3 my-3" :endpoint="endpoint" method="POST" @submit.prevent="handleSave">
        <slot name="csrf" />
        <h4 class="h4 uppercase !font-semibold !mb-0">ASK Team Contact Form</h4>
        <div class="relative">
            <select
                id="ticket-type"
                name="ticket-type"
                required
                v-model="ticketType"
                placeholder=""
                class="peer seint-floating-input seint-input"
            >
                <option disabled>Ticket Category*</option>
                <option v-for="option in options" :value="option">
                    {{ option }}
                </option>
            </select>
            <label for="ticket-type" class="seint-floating-select-label seint-input">Ticket Category*</label>
        </div>
        <slot name="auth-fields" />
        <div class="relative">
            <input
                type="text"
                name="order-number"
                id="ticket-order-number"
                placeholder="Order Number"
                v-model="orderNumber"
                v-mask="'###########'"
                autocomplete="off"
                class="peer seint-floating-input seint-input"
            />
            <label for="ticket-order-number" class="seint-floating-label seint-input">
                Order Number
            </label>
        </div>
        <div class="relative">
            <input
                type="text"
                name="subject"
                id="ticket-subject"
                placeholder="Subject*"
                v-model="subject"
                autocomplete="off"
                required
                class="peer seint-floating-input seint-input"
            />
            <label for="ticket-subject" class="seint-floating-label seint-input">
                Subject*
            </label>
        </div>
        <div class="relative">
            <label for="ticket-order-number" class="seint-floating-textarea-label before:content[' '] after:content[' '] seint-input">
                Tell us how we can help
            </label>
            <textarea name="description" id="ticket-description" v-model="description" required rows="5" class="peer seint-textarea seint-input" />
        </div>
        <section>
            <h4 class="h4 uppercase !font-semibold">Attach an image or file</h4>
            <image-upload ref="filepond" name="attachments[]" label="Drag & Drop" multiple accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf" />
        </section>
        <!-- <section>
            <label for="additionalEmail" class="cursor-pointer">
                <span class="relative">
                    <input
                        class="peer seint-checkbox"
                        type="checkbox"
                        id="additionalEmail"
                        name="additionalEmail"
                        v-model="additionalEmail"
                    />
                    <svg-vue
                        icon="checkmark"
                        class="w-2 h-2 fill-white absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-[3px] z-10 transition-opacity opacity-0 peer-checked:opacity-100"
                    />
                </span>
                CC another email
            </label>
            <template v-if="additionalEmail">
                <div class="relative mt-3">
                    <input
                        type="email"
                        name="cc-email"
                        id="cc-email"
                        placeholder="CC Email"
                        autocomplete="email"
                        required
                        class="peer seint-floating-input seint-input"
                    />
                    <label for="cc-email" class="seint-floating-label seint-input">
                        CC Email
                    </label>
                </div>
            </template>
        </section> -->
        <button type="submit" class="seint-btn" :disabled="isDisabled || loading">
            <loader v-if="loading" class="" /><span v-else>{{ btnText }}</span>
        </button>
        <p v-if="success" class="error p-3 mt-2 bg-green-200 text-green-900">{{ success }}</p>
        <slot name="success" />
        <p v-if="error" class="error p-3 mt-2 bg-red-200 text-red-900">{{ error }}</p>
        <slot name="error" />
    </form>
</template>
<script setup>
import { ref, computed } from "vue"
import axios from 'axios'

const props = defineProps({
    endpoint: {
        type: String,
        required: true,
    },
    options: {
        type: Array,
        required: true,
    },
    initialTicketType: {
        type: String,
        required: false,
        default: '',
    },
    initialOrderNumber: {
        type: String,
        required: false,
        default: '',
    },
    initialSubject: {
        type: String,
        required: false,
        default: '',
    },
    initialDescription: {
        type: String,
        required: false,
        default: '',
    },
    btnText: {
        type: String,
        default: 'Send'
    }
})

const contactForm = ref(null)
const filepond = ref(null)
const loading = ref(false)
const success = ref(null)
const error = ref(null)
const ticketType = ref(props.initialTicketType)
const orderNumber = ref(props.initialOrderNumber)
const subject = ref(props.initialSubject)
const description = ref(props.initialDescription)
const additionalEmail = ref(false)

const isDisabled = computed(() => {
    const isLoading = loading.value
    const ticketTypeEmpty = ticketType.value?.trim().length === 0
    const subjectEmtpy = subject.value?.trim().length === 0
    const descriptionEmpty = description.value?.trim().length === 0
    return [isLoading, ticketTypeEmpty, subjectEmtpy, descriptionEmpty].some(Boolean)
})

const handleSave = async () => {
    try {
        const formData = new FormData(contactForm.value)
        loading.value = true
        error.value = null
        success.value = null
        const { data } = await axios.post(props.endpoint, formData)
        loading.value = false
        success.value = data.message ?? 'Message Sent!'
        contactForm.value.reset() // slotted inputs
        ticketType.value = null
        orderNumber.value = null
        subject.value = null
        description.value = null
        filepond.value.handleReset() // image-upload
    } catch (err) {
        error.value = err.response?.data.message ?? 'An error occured. Please try again'
        loading.value = false
    }
}
</script>
